module.exports = "<div class=\"global-notices\" *ngIf=\"notices.length > 0\">\n  <div *ngFor=\"let notice of notices\" class=\"text-center mb0 alert alert-{{ notice.type }}\">\n    <strong>{{ notice.title }}!</strong> {{ notice.body }}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/notices/notices.component.html
// module id = ../../../../../src/app/shared/components/notices/notices.component.html
// module chunks = main